import { NocfoPlan, NocfoPlanSource } from '@constants'

export const LUCA_PAYG_ADDON_ID = 'luca'
export const LUCA_PAYG_PRODUCT_KEY = 'luca_out'

export interface LucaPaygPaymentMethodState {
  luca_payg_allowed?: boolean
  luca_payg_available?: boolean
  stripe_payg_checkout_enabled?: boolean
  subscription_plan?: string
  subscription_source?: string
}

/** Pay-as-you-go consent is on, but Stripe cannot bill it because no payment method is saved. */
export const isLucaPaygBlockedByMissingPaymentMethod = (
  business: LucaPaygPaymentMethodState | null | undefined
): boolean =>
  Boolean(business?.luca_payg_allowed) &&
  business?.luca_payg_available === false &&
  business?.stripe_payg_checkout_enabled === true &&
  business?.subscription_source === NocfoPlanSource.STRIPE &&
  business?.subscription_plan !== NocfoPlan.FREE

export const isLucaPaygAddon = (addonId: string): boolean => addonId === LUCA_PAYG_ADDON_ID

export const isLucaPaygUsageItem = (productKey: string | null | undefined): boolean =>
  productKey === LUCA_PAYG_PRODUCT_KEY

export const LUCA_PAYG_ADDON_OFFERED = false
